<template>
    <card
        color="blue"
        small
        stretched
        :link="{ url: cardData.url, text: cardData.urlName }"
    >
        <template v-if="cardData.isSubscribed" v-slot:top>Subscribed</template>
        <h2>{{ cardData.text }}</h2>
    </card>
</template>

<script>
import card from '@/components/cards/card';
export default {
    components: {
        card
    },
    props: {
        cardData: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>
